{
  "name": "@schafzucht-2025/source",
  "version": "1.8.0",
  "versiondev": "1.8.0-staging.234",
  "license": "MIT",
  "scripts": {
    "lint": "nx run-many --target=lint --all",
    "prepare": "husky",
    "release:dev": "echo \"Dev release disabled: version and changelog are only generated on master\"",
    "release:prod": "standard-version --no-verify",
    "release:prod:minor": "standard-version --release-as minor --no-verify",
    "release:prod:major": "standard-version --release-as major --no-verify",
    "buildTest": "npx nx run schafzucht_2025:build:development",
    "buildStaging": "npx nx run schafzucht_2025:build:staging && pnpm sentry:sourcemaps",
    "build": "npx nx run schafzucht_2025:build:production && pnpm sentry:sourcemaps",
    "gitbuild": ".\\apps\\actions-runner\\run.cmd",
    "startactionrunner": "",
    "startapilocal": "cross-env NODE_ENV=development nodemon main.ts",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mksoft-it-service-consulting --project smartsheep ./dist && sentry-cli sourcemaps upload --org mksoft-it-service-consulting --project smartsheep ./dist"
  },
  "dependencies": {
    "@angular/common": "22.1.5",
    "@angular/compiler": "22.1.5",
    "@angular/core": "22.1.5",
    "@angular/forms": "22.1.5",
    "@angular/platform-browser": "22.1.5",
    "@angular/pwa": "22.1.7",
    "@angular/router": "22.1.5",
    "@angular/service-worker": "22.1.5",
    "@fontsource-variable/dm-sans": "^5.3.0",
    "@fontsource/nunito": "^5.3.0",
    "@fontsource/nunito-sans": "^5.3.0",
    "@fortawesome/fontawesome-free": "^7.3.1",
    "@ngrx/operators": "21.1.0",
    "@ngrx/signals": "21.1.0",
    "@sentry/angular": "^10.75.3",
    "@sentry/cli": "^3.8.0",
    "@tailwindcss/postcss": "^4.3.3",
    "axios": "1.20.0",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.4",
    "postcss": "^8.5.28",
    "rxjs": "~7.8.2",
    "swagger-autogen": "^2.23.7",
    "swagger-ui-express": "^5.0.1",
    "tailwindcss": "^4.3.3",
    "tailwindcss-safe-area": "^1.3.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "22.1.7",
    "@angular-devkit/schematics": "22.1.7",
    "@angular-eslint/eslint-plugin": "22.2.0",
    "@angular-eslint/eslint-plugin-template": "22.2.0",
    "@angular/build": "22.1.7",
    "@angular/cli": "22.1.7",
    "@angular/compiler-cli": "22.1.5",
    "@angular/language-service": "22.1.5",
    "@commitlint/cli": "^21.2.3",
    "@commitlint/config-conventional": "^21.2.3",
    "@commitlint/types": "^21.2.3",
    "@eslint/js": "^10.0.1",
    "@nx/angular": "23.3.0",
    "@nx/eslint": "23.3.0",
    "@nx/eslint-plugin": "23.3.0",
    "@nx/js": "23.3.0",
    "@nx/node": "23.3.0",
    "@nx/web": "23.3.0",
    "@nx/webpack": "23.3.0",
    "@nx/workspace": "23.3.0",
    "@pmmmwh/react-refresh-webpack-plugin": "^0.6.3",
    "@schematics/angular": "22.2.0",
    "@svgr/webpack": "^8.1.0",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.2",
    "@swc/helpers": "0.5.23",
    "@types/node": "^26.6.2",
    "@typescript-eslint/utils": "^8.70.1",
    "angular-eslint": "22.5.0",
    "conventional-changelog-angular": "^9.4.0",
    "conventional-changelog-conventionalcommits": "^10.4.1",
    "dotenv": "^17.4.2",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "husky": "^9.1.7",
    "nx": "23.3.0",
    "prettier": "^3.9.9",
    "react-refresh": "^0.19.0",
    "standard-version": "^9.5.0",
    "tslib": "^2.8.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.1",
    "webpack": "^5.111.1",
    "webpack-cli": "7.2.2",
    "webpack-dev-server": "^5.2.6"
  },
  "packageManager": "pnpm@12.3.4"
}
